module.exports = __webpack_public_path__ + "static/img/not-found.2a0101e5.png";